function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M38.225 107.725h-20.85a3.475 3.475 0 0 1-3.475-3.475V69.5a3.475 3.475 0 0 1 3.475-3.475h20.85V16.531a6.16 6.16 0 0 1 1.768-4.327 5.953 5.953 0 0 1 4.262-1.779h50.014l30.831 27.8v84.244c0 3.372-2.688 6.106-6.004 6.106H44.255a5.953 5.953 0 0 1-4.262-1.78 6.159 6.159 0 0 1-1.768-4.326v-14.744z",
  id: "b"
}), React.createElement("filter", {
  x: "-24.7%",
  y: "-22.4%",
  width: "149.5%",
  height: "146.6%",
  filterUnits: "objectBoundingBox",
  id: "a"
}, React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 9,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feOffset", {
  dy: 6,
  in: "SourceAlpha",
  result: "shadowOffsetOuter3"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter3",
  result: "shadowBlurOuter3"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0",
  in: "shadowBlurOuter3",
  result: "shadowMatrixOuter3"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter3"
}))), React.createElement("path", {
  d: "M48.603 14.714c.176.033.354.056.534.068h62.028c2.843.17 5 2.364 4.825 4.91v78.41c.167 2.541-1.987 4.728-4.825 4.898H4.847c-2.843-.164-5.005-2.352-4.838-4.898V14.714H0V5.636c-.003-1.496.693-2.93 1.936-3.988C3.179.59 4.865-.002 6.622 0H47.43c2.082.003 4.041.834 5.296 2.248l9.263 10.52c.828.916 1.966 1.596 3.261 1.946H48.603z",
  id: "d"
}), React.createElement("filter", {
  x: "-23.7%",
  y: "-25.7%",
  width: "147.4%",
  height: "153.4%",
  filterUnits: "objectBoundingBox",
  id: "c"
}, React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 9,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feOffset", {
  dy: 6,
  in: "SourceAlpha",
  result: "shadowOffsetOuter3"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter3",
  result: "shadowBlurOuter3"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0",
  in: "shadowBlurOuter3",
  result: "shadowMatrixOuter3"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter3"
}))), React.createElement("path", {
  d: "M38.225 107.725h-20.85a3.475 3.475 0 0 1-3.475-3.475V69.5a3.475 3.475 0 0 1 3.475-3.475h20.85V16.531a6.16 6.16 0 0 1 1.768-4.327 5.953 5.953 0 0 1 4.262-1.779h50.014l30.831 27.8v84.244c0 3.372-2.688 6.106-6.004 6.106H44.255a5.953 5.953 0 0 1-4.262-1.78 6.159 6.159 0 0 1-1.768-4.326v-14.744z",
  id: "f"
}), React.createElement("filter", {
  x: "-24.7%",
  y: "-22.4%",
  width: "149.5%",
  height: "146.6%",
  filterUnits: "objectBoundingBox",
  id: "e"
}, React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 9,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feOffset", {
  dy: 6,
  in: "SourceAlpha",
  result: "shadowOffsetOuter3"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter3",
  result: "shadowBlurOuter3"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0",
  in: "shadowBlurOuter3",
  result: "shadowMatrixOuter3"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter3"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(15 6)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#F6F6F6",
  cx: 128.996,
  cy: 131,
  r: 97
}), React.createElement("g", {
  transform: "translate(49.996)"
}, React.createElement("path", {
  d: "M0 0h139v139H0z"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
}), React.createElement("use", {
  fill: "#FAFAFA",
  xlinkHref: "#b"
}), React.createElement("path", {
  d: "M125.1 39.02v83.449c0 3.372-2.688 6.106-6.004 6.106H44.255a5.953 5.953 0 0 1-4.262-1.78 6.159 6.159 0 0 1-1.768-4.326V16.53a6.16 6.16 0 0 1 1.768-4.327 5.953 5.953 0 0 1 4.262-1.779h50.014L125.1 39.02z",
  fill: "#E2E5E7"
}), React.createElement("path", {
  d: "M125.1 38.225l-30.83-27.8-.32 22.45c-.008 1.416.61 2.777 1.718 3.781 1.107 1.005 2.613 1.569 4.183 1.569H125.1z",
  fill: "#B0B7BD"
}), React.createElement("path", {
  fill: "#CAD1D8",
  d: "M125.1 38.225V62.55l-24.325-24.325z"
}), React.createElement("rect", {
  fill: "#147FC1",
  x: 13.9,
  y: 66.025,
  width: 97.3,
  height: 41.7,
  rx: 1
}), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "proxima-nova",
  fontSize: 27,
  fontWeight: "bold"
}, React.createElement("tspan", {
  x: 28.142,
  y: 95
}, "BIOM"))), React.createElement("g", {
  transform: "rotate(7 -666.07 153.194)"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#c)",
  xlinkHref: "#d"
}), React.createElement("use", {
  fill: "#FAFAFA",
  xlinkHref: "#d"
})), React.createElement("path", {
  d: "M76.675 104.872c-1.242-.506-2.289-1.319-2.999-2.33l-7.912-11.57c-1.073-1.555-2.917-2.62-4.982-2.876l-40.504-4.973c-1.744-.217-3.49.165-4.852 1.064-1.363.898-2.23 2.238-2.408 3.723l-1.106 9.01 64.763 7.952z",
  fill: "#B0B7BD"
}), React.createElement("path", {
  d: "M122.24 110.535l-61.566-7.559a4.61 4.61 0 0 1-.521-.133L11.92 96.921 1.758 179.687c-.475 2.507 1.403 4.942 4.205 5.451l105.526 12.957c2.837.177 5.242-1.73 5.386-4.273l9.556-77.826c.483-2.505-1.39-4.945-4.191-5.46z",
  fill: "#E2E5E7"
}), React.createElement("path", {
  d: "M76.675 104.872c-1.242-.506-2.289-1.319-2.999-2.33l-7.912-11.57c-1.073-1.555-2.917-2.62-4.982-2.876l-40.504-4.973c-1.744-.217-3.49.165-4.852 1.064-1.363.898-2.23 2.238-2.408 3.723l-1.106 9.01 64.763 7.952z",
  fill: "#B0B7BD"
}), React.createElement("path", {
  d: "M122.24 110.535l-61.566-7.559a4.61 4.61 0 0 1-.521-.133L11.92 96.921 1.758 179.687c-.475 2.507 1.403 4.942 4.205 5.451l105.526 12.957c2.837.177 5.242-1.73 5.386-4.273l9.556-77.826c.483-2.505-1.39-4.945-4.191-5.46z",
  fill: "#E2E5E7"
}), React.createElement("g", {
  transform: "rotate(-14 381.767 -376.94)"
}, React.createElement("path", {
  d: "M0 0h139v139H0z"
}), React.createElement("use", {
  fill: "#000",
  filter: "url(#e)",
  xlinkHref: "#f"
}), React.createElement("use", {
  fill: "#FAFAFA",
  xlinkHref: "#f"
}), React.createElement("path", {
  d: "M125.1 39.02v83.449c0 3.372-2.688 6.106-6.004 6.106H44.255a5.953 5.953 0 0 1-4.262-1.78 6.159 6.159 0 0 1-1.768-4.326V16.53a6.16 6.16 0 0 1 1.768-4.327 5.953 5.953 0 0 1 4.262-1.779h50.014L125.1 39.02z",
  fill: "#E2E5E7"
}), React.createElement("path", {
  d: "M125.1 38.225l-30.83-27.8-.32 22.45c-.008 1.416.61 2.777 1.718 3.781 1.107 1.005 2.613 1.569 4.183 1.569H125.1z",
  fill: "#B0B7BD"
}), React.createElement("path", {
  fill: "#CAD1D8",
  d: "M125.1 38.225V62.55l-24.325-24.325z"
}), React.createElement("rect", {
  fill: "#F4805D",
  x: 13.9,
  y: 66.025,
  width: 97.3,
  height: 41.7,
  rx: 1
}), React.createElement("text", {
  fill: "#FFF",
  fontFamily: "proxima-nova",
  fontSize: 27,
  fontWeight: "bold"
}, React.createElement("tspan", {
  x: 36.059,
  y: 95
}, "CSV"))));

var SvgDragAndDropBanner = function SvgDragAndDropBanner(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 286,
    height: 234,
    viewBox: "0 0 286 234",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDragAndDropBanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drag-and-drop-banner.3bcb5faf.svg";
export { ForwardRef as ReactComponent };